module.exports = __webpack_public_path__ + "img/ELF.e9c25ff5.svg";